import request from '@/utils/request'

// 获取广告主列表
export function getAdvertiserList(obj = {}) {
  const str = splicing(obj)
  return request({
    url: `/novel_management/wechat_advertisers?${str}`,
    method: 'get'
  })
}
// 获取广告主列表
export function getAdvertiserList1(params) {
  return request({
    url: `/novel_management/wechat_advertisers`,
    method: 'get',
    params
  })
}

// 获取历史记录
export function getHistoricalRecords(id) {
  return request({
    url: `/novel_management/wechat_advertisers/${id}`,
    method: 'get'
  })
}

// 修改广告主
export function modifyAdvertiser(id, data) {
  return request({
    url: `/novel_management/wechat_advertisers/${id}`,
    method: 'put',
    data
  })
}

// 添加广告主
export function addAdvertiser(data = {}) {
  return request({
    url: `/novel_management/wechat_advertisers`,
    method: 'POST',
    data
  })
}

function splicing(obj) {
  let str = ''
  for (const key in obj) {
    str += obj[key] ? `${key}=${obj[key]}&` : ''
  }
  str = str ? str.substring(0, str.length - 1) : str
  return str
}
